export enum HorizontalAlignment {
    None = 0,
    Left = 1,
    Center = 2,
    Right = 3,
    Stretch = 4,
}